import React, { useEffect, useState } from 'react';
// import logo from './logo.svg';
import './App.css';
// import LoginScreen from './pages/LoginScreen/LoginScreen';
import RegisterScreen from './pages/Register/Register';
import WithTheme from './theme/WithTheme';
import appTheme from './theme/AppTheme';
import Routes from './routes/Routes';

function App() {
  console.log(process.env.REACT_APP_URI);
  const [isDarkMode, setIsDarkMode] = useState(false);
  console.log(isDarkMode);
  useEffect(() => {
    // Function to switch favicon based on the theme mode
    const updateFavicon = () => {
      const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
      setIsDarkMode(darkMode);
      const lightFavicon = document.getElementById('favicon-light');
      const darkFavicon = document.getElementById('favicon-dark');

      if (darkMode) {
        console.log('dark', darkFavicon, lightFavicon);
        // If dark mode is active, set the dark favicon
        darkFavicon?.setAttribute('rel', 'icon');
        lightFavicon?.setAttribute('rel', 'alternate-icon');
      } else {
        console.log('light', lightFavicon, darkFavicon);
        // If light mode is active, set the light favicon
        lightFavicon?.setAttribute('rel', 'icon');
        darkFavicon?.setAttribute('rel', 'alternate-icon');
      }
    };

    // Run the function on component mount
    updateFavicon();

    // Optionally listen for theme changes and update the favicon dynamically
    const mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
    const listener = (e: MediaQueryListEvent) => {
      updateFavicon();
    };

    mediaQueryList.addEventListener('change', listener);

    // Cleanup listener when component unmounts
    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, []);

  return (
    <div className='App'>
      <Routes />
    </div>
  );
}

export default WithTheme(appTheme, App, true);
